<section class="super-admin-home pt-9">
  <div class="main-container">
    <section class="actions-container">
      <div class="title-container">
        <h1>Requests summary</h1>
        <label for="">Last updated {{ todayDate }}</label>
      </div>
      <!-- <div class="btn-container">
        <gbui-button
          class="buttons-outline"
          [routerLink]="['/dashboard/company/add-company']"
          routerLinkActive="router-link-active"
          >Add New Company</gbui-button
        >
      </div> -->
    </section>
    <section class="counters-cards">
      <ng-template [ngIf]="allUsers$ | async" let-users>
        <div class="card">
          <div class="inner-container">
            <label for="" class="total"> {{ users }} </label>
            <label for="" class="title"> Total Customers </label>
          </div>
        </div>
      </ng-template>
      <ng-template [ngIf]="(allUsers$ | async) == 0">
        <div class="card">
          <div class="inner-container">
            <label for="" class="total"> 0 </label>
            <label for="" class="title"> Total Customers </label>
          </div>
        </div>
      </ng-template>

      <ng-template [ngIf]="gettingUsers$ | async">
        <div class="card p-5">
          <div class="inner-container">
            <loader></loader>
            <!-- <mat-spinner class="mat-spinner-color"></mat-spinner> -->
          </div>
        </div>
      </ng-template>
      <ng-template [ngIf]="activeUsers$ | async" let-users>
        <div class="card">
          <div class="inner-container">
            <label for="" class="total"> {{ users }} </label>
            <label for="" class="title"> Active users </label>
          </div>
        </div>
      </ng-template>
      <ng-template [ngIf]="(activeUsers$ | async) == 0">
        <div class="card">
          <div class="inner-container">
            <label for="" class="total"> 0 </label>
            <label for="" class="title"> Active users </label>
          </div>
        </div>
      </ng-template>
      <ng-template [ngIf]="gettingActiveUsers$ | async">
        <div class="card p-5">
          <div class="inner-container">
            <loader></loader>
            <!-- <mat-spinner class="mat-spinner-color"></mat-spinner> -->
          </div>
        </div>
      </ng-template>
    </section>
    <ng-template [ngIf]="notifications$ | async">
      <section class="notifications">
        <h2>Notifications</h2>
        <div
          class="empty-notifications-container"
          *ngIf="notifications.length == 0"
        >
          <h3>No pending notifications</h3>
        </div>
        <div class="">
          <div class="slideshow-container">
            <div
              class="mySlides fade"
              *ngFor="let sections of notifications; let index = index"
            >
              <div class="items-container">
                <div class="carousel-item" *ngFor="let item of sections.slice">
                  <label class="title"> {{ item.title }} </label>

                  <label for="" class="description"> {{ item.content }} </label>
                  <label class="sender" *ngIf="item?.meta?.sender">
                    - {{ item?.meta?.sender }}
                  </label>

                  <div class="date-container">
                    <label for=""> {{ item?.createdAt }} </label>
                  </div>
                  <img
                    (click)="closeNotification(item._id)"
                    src="/assets/icons/x-circle.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <br />
        </div>
      </section>
    </ng-template>

    <!--
  **
  * Carousel
  **
 -->

    <section
      class="slider-wrapper"
      *ngIf="notifications && notifications.length > 0"
    >
      <button
        class="slide-arrow"
        id="slide-arrow-prev"
        [ngClass]="{ 'hide-arrow': currentIndex > 1 }"
      >
        &#8249;
      </button>
      <button
        class="slide-arrow"
        id="slide-arrow-next"
        [ngClass]="{ 'hide-arrow': currentIndex < dotsCarouselArray.length }"
      >
        &#8250;
      </button>
      <ul class="slides-container" id="slides-container">
        <li
          class="slide"
          *ngFor="let sections of dotsCarouselArray; let sectionIndex = index"
        >
          <div class="dots-wrapper">
            <div class="dots-container">
              <ng-container *ngIf="sections.slice.length > 0">
                <span
                  class="dot"
                  (click)="currentSlide(sectionIndex * 5 + i + 1)"
                  *ngFor="let item of sections.slice; let i = index"
                ></span>
              </ng-container>
            </div>
          </div>
        </li>
        <!-- <li class="slide"></li>
        <li class="slide"></li>
        <li class="slide"></li>
        <li class="slide"></li>
        <li class="slide"></li> -->
      </ul>
    </section>

    <ng-template [ngIf]="companies$ | async" let-companies>
      <section class="table-container">
        <h2>My companies</h2>
        <table>
          <thead>
            <tr>
              <th>Company name</th>
              <th>Address</th>
              <th>Industry</th>
              <th class="w-p-20">Status</th>
              <th class="w-40px"></th>
            </tr>
          </thead>

          <tbody>
            <tr
              *ngFor="
                let company of companies
                  | paginate
                    : {
                        itemsPerPage: itemsPerPages,
                        currentPage: currentPage,
                        id: 'companiesTable',
                        totalItems: companies.length
                      }
              "
            >
              <td>
                <label for=""> {{ company.companyName }} </label>
                <ng-container *ngIf="company?._parentCompanyId">
                  <label
                    class="child-label"
                    *ngIf="
                      company?.parentCompany && company?.parentCompany?.length
                    "
                    matTooltipClass="my-tooltip"
                    [matTooltip]="
                      'Parent Company \n\n' +
                      'Name: ' +
                      company.parentCompany[0].companyName +
                      ',' +
                      '\n' +
                      'Address: ' +
                      company.parentCompany[0].address.street1 +
                      ' , ' +
                      company.parentCompany[0].address.country +
                      ',' +
                      '\n' +
                      'Email: ' +
                      company.parentCompany[0].email
                    "
                    >Child</label
                  >
                </ng-container>
              </td>
              <td>
                <label for="">
                  {{
                    company?.address?.street1 && company?.address?.city
                      ? company.address.street1 +
                        ", " +
                        company.address.city +
                        ", " +
                        company.address.state +
                        "," +
                        company.address.zip
                      : "N/A"
                  }}
                </label>
              </td>
              <td style="width: 35% !important" class="capitalize">
                {{ toTitleCase(company.industry) }}
              </td>
              <td class="w-p-20 capitalize">{{ company.status }}</td>
              <td class="w-40px option">
                <button
                  mat-icon-button
                  [matMenuTriggerFor]="menu"
                  aria-label="Example icon-button with a menu"
                >
                  <mat-icon>list</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button (click)="deleteCompany(company)" mat-menu-item>
                    <span>Delete</span>
                  </button>
                  <button
                    (click)="navigateToCompanyDetails(company.id)"
                    mat-menu-item
                  >
                    <span>View details</span>
                  </button>
                </mat-menu>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <section class="paginator">
        <label for="">
          {{ currentPage * itemsPerPages - itemsPerPages + 1 }} - {{ currentPage
          * itemsPerPages >= companies.length ? companies.length : currentPage *
          itemsPerPages }} of {{ companies.length }}</label
        >

        <pagination-controls
          id="companiesTable"
          (pageChange)="pageChanged($event)"
          previousLabel=""
          nextLabel=""
        ></pagination-controls>
      </section>
    </ng-template>
    <ng-template [ngIf]="companiesLoading$ | async">
      <div class="loader-container">
        <loader></loader>
        <!-- <mat-spinner class="mat-spinner-color" [diameter]="150"></mat-spinner> -->
      </div>
    </ng-template>
  </div>
</section>
